import * as React from "react";
import styles = require("./style.less");
import Expandable, {ExpandableProps} from "components/Expandable/Expandable";
import CardExpandable from "components/form/Sections/CardExpandable";

interface SimpleExpanderProps {
    error?: string;
    title: React.ReactNode;
    onDidExpand?(expanded: boolean): void;
    children?: React.ReactNode;
}

type Props = SimpleExpanderProps & ExpandableProps;

export class SimpleExpanderInternal extends React.Component<Props> {

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        if (this.props.isExpanded !== nextProps.isExpanded) {
            if (nextProps.onDidExpand) {
                nextProps.onDidExpand(nextProps.isExpanded);
            }
        }
    }

    // we can't just use actAsExpander on card Title because it eats the click
    // and we can't add links to the title in help text or our show more info link
    handleExpand = (e: any) => {
        e.preventDefault();
        const isExpanded = !this.props.isExpanded;
        this.props.onExpandedChanged(isExpanded);
    }

    renderChild = (child: any): any => {
        if (!child) {
            return child;
        }
        const children = child.props && child.props.children
            ? {children: this.renderChildren(child.props.children)}
            : null;

        const props = children ? {...child.props, ...children} : child.props;
        return React.isValidElement(child) ? React.cloneElement(child, props) : child;
    }

    renderChildren = (children: any) => {
        return React.Children.map(children, this.renderChild);
    }

    render() {
        return <div className={styles.formExpander}>
            <div
                onClick={(e: any) => this.handleExpand(e)}
                style={{cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between"}}
            >
                <div style={{flex: 1}}>{this.props.title}</div>
                <CardExpandable expanded={this.props.isExpanded} onExpanding={(e: any) => this.handleExpand(e)} />
            </div>
            {this.props.isExpanded && (
                <div className={styles.cardMedia}>
                    <div>
                        {this.renderChildren(this.props.children)}
                    </div>
                </div>
            )}
        </div>;
    }
}

const SimpleExpander = Expandable<SimpleExpanderProps>(SimpleExpanderInternal);
export default SimpleExpander;
